import { type FormEventHandler, useRef } from "react";
import { Button } from "_c/Button";
import type { CreateCommentMutationVariables } from "@/typings/wp";
import { useMutation } from "@tanstack/react-query";
import cls from "./styles.module.css";
import { useCreateCommentRequest } from "@/hooks/network/use-create-comment-request";
import type { TRespondTarget } from "./typings";

type TProps = {
  postId: number;
  respondTarget: TRespondTarget | null;
  resetRespondTarget: () => void;
};
export default function CommentForm(props: TProps) {
  const createComment = useCreateCommentRequest();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const msgRef = useRef<HTMLTextAreaElement>(null);
  const mutation = useMutation({
    mutationFn: (data: CreateCommentMutationVariables) =>
      createComment({ data }),
  });
  const onSubmit: FormEventHandler = async (e) => {
    e.preventDefault();
    mutation.mutate(
      {
        postId: props.postId,
        email: emailRef.current!.value,
        name: nameRef.current!.value,
        comment: msgRef.current!.value,
        parent: String(props.respondTarget?.commentId),
      },
      {
        onSuccess: () => {
          nameRef.current!.value = "";
          emailRef.current!.value = "";
          msgRef.current!.value = "";
          props.resetRespondTarget();
          alert("Спасибо за комментарий!");
        },
        onError: () => {
          alert("Ошибка при отправлении комментария");
        },
      },
    );
  };
  return (
    <form className={cls.form} onSubmit={onSubmit}>
      {props.respondTarget && (
        <div className={cls.respondTarget}>
          <span>Ответ пользователю</span>{" "}
          <strong>{props.respondTarget.authorName}</strong>
          <button type="button" onClick={props.resetRespondTarget}>
            Отменить
          </button>
        </div>
      )}
      <div className={cls.field}>
        <label htmlFor="comment-form_message">Комментарий</label>
        <textarea ref={msgRef} rows={4} id="comment-form_message" required />
      </div>
      <div className={cls.field}>
        <label htmlFor="comment-form_name">Имя</label>
        <input ref={nameRef} id="comment-form_name" required />
      </div>
      <div className={cls.field}>
        <label htmlFor="comment-form_email">Email</label>
        <input ref={emailRef} id="comment-form_email" type="email" required />
      </div>
      <Button disabled={mutation.isPending} type="submit">
        Отправить
      </Button>
    </form>
  );
}
